import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["label", "onChange", "checked", "disabled", "name", "className"];
import React from 'react';
import { Switch } from '@mch-group/uikit-components';
import PropTypes from 'prop-types';

var ToggleSwitch = function ToggleSwitch(_ref) {
  var label = _ref.label,
      onChange = _ref.onChange,
      checked = _ref.checked,
      disabled = _ref.disabled,
      name = _ref.name,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Switch, _extends({
    name: name,
    label: label,
    onChange: onChange,
    checked: checked,
    disabled: disabled,
    toggle: true,
    className: className
  }, props));
};

ToggleSwitch.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  className: PropTypes.string
};
ToggleSwitch.defaultProps = {
  disabled: false
};
export default ToggleSwitch;